import React from "react";
import {TextToolTip} from "../table";

export const IconsBadge = ({text, content}) => {
    return (
        <TextToolTip
            showTooltip
            arrow
            content={content}
            text={text}
            wrapperStyles={{width:'fit-content'}}
            textStyles={{width:'fit-content'}}
        />
    );
};
